import { Box, Card, Divider, Grid, Typography } from '@mui/material';
import './TourDays.scss';
import { Icon } from '@iconify/react';
const TourDays = ({ header, tableHeaders, onClose, availability }: any) => {
  return (
    <Box className='regular-tourdays'>
      <Card className='regulartourdays-table'>
        <Box className='regulartourdays-header'>
          <Typography sx={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
            {header}
          </Typography>
          <Icon
            icon='mdi:close-circle'
            style={{ cursor: 'pointer', color: '#fff', fontSize: '1.8rem' }}
            onClick={onClose}
          />
        </Box>
        <Box className='regular-tourtableheaders'>
          <Grid container>
            {tableHeaders?.map(({ head, size }: any) => {
              return (
                <Grid item lg={size} key={head}>
                  <Typography sx={{ color: '#333', fontSize: '1rem' }}>{head}</Typography>
                </Grid>
              );
            })}
          </Grid>
        </Box>
        <Box className='regular-tourdatas'>
          <Grid container spacing={2} textAlign={'center'}>
            {availability?.map(({ label, available }: any, index: number) => (
              <>
                <Grid item lg={6}>
                  <Typography
                    sx={{ fontWeight: 'bold', color: '#1565c0', fontSize: '1rem' }}
                  >
                    {label}
                  </Typography>
                </Grid>
                <Grid item lg={6}>
                  <Typography sx={{ color: '#333', fontSize: '0.95rem' }}>
                    {available}
                  </Typography>
                </Grid>

                {availability?.length - 1 > index && (
                  <Grid item lg={12}>
                    <Divider sx={{ backgroundColor: '#ddd' }} />
                  </Grid>
                )}
              </>
            ))}
          </Grid>
        </Box>
      </Card>
    </Box>
  );
};

export default TourDays;
